function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-48 -80)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.385,88.462a.769.769,0,0,1,.769-.769h6.923v-5A3.032,3.032,0,0,0,58,80H50.692A2.7,2.7,0,0,0,48,82.692V94.231a2.7,2.7,0,0,0,2.692,2.692h7.692a2.7,2.7,0,0,0,2.692-2.692v-5H54.154A.769.769,0,0,1,53.385,88.462Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.7,164.348l-3.846-3.846a.769.769,0,0,0-1.088,1.088l2.533,2.533H320v1.538h4.3l-2.533,2.533a.769.769,0,1,0,1.088,1.088l3.846-3.846A.769.769,0,0,0,326.7,164.348Z",
  transform: "translate(-258.923 -76.43)",
  fill: "currentColor"
}));

var SvgSender = function SvgSender(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    viewBox: "0 0 20 16.923",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSender, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sender.0907e162.svg";
export { ForwardRef as ReactComponent };